/**
 * Fallback Renderer
 * 
 * Renders a fallback view for unsupported or unknown visualization types.
 */

import type { VisualizationRenderer } from '../registry.js';
import { designTokens, escapeHtml } from '../../../core/design-system.js';

export const renderFallback: VisualizationRenderer = (data, meta) => {
  const title = meta?.title || 'Unsupported Visualization';
  const description = meta?.description || 'This visualization type is not yet implemented.';
  
  // Try to render data as JSON if it's an object
  let dataHTML = '';
  if (data !== null && data !== undefined) {
    try {
      const dataStr = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
      dataHTML = `
        <div style="
          margin-top: ${designTokens.padding.md};
          padding: ${designTokens.padding.md};
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid ${designTokens.borderColor};
          border-radius: ${designTokens.radius.sm};
          font-family: monospace;
          font-size: ${designTokens.fontSize.xs};
          color: ${designTokens.contentColorMuted};
          white-space: pre-wrap;
          word-break: break-word;
          max-height: 400px;
          overflow: auto;
        ">${escapeHtml(dataStr)}</div>
      `;
    } catch (error) {
      dataHTML = `
        <div style="
          margin-top: ${designTokens.padding.md};
          padding: ${designTokens.padding.md};
          color: ${designTokens.contentColorMuted};
          font-size: ${designTokens.fontSize.sm};
        ">Unable to display data</div>
      `;
    }
  }

  return `
    <div style="
      padding: ${designTokens.padding.xl};
      text-align: center;
    ">
      <div style="
        font-size: ${designTokens.fontSize.lg};
        color: ${designTokens.contentColorMuted};
        margin-bottom: ${designTokens.padding.md};
      ">📊 ${escapeHtml(title)}</div>
      <div style="
        font-size: ${designTokens.fontSize.sm};
        color: ${designTokens.contentColorMuted};
        margin-bottom: ${designTokens.padding.lg};
      ">${escapeHtml(description)}</div>
      ${dataHTML}
    </div>
  `;
};


